export default __webpack_public_path__ + "static/callum-faris-portrait-bc1d16fb602e6389617a35f60b756a1c.webp";